// Mirror of the server-side permission codes used for UI gating.
// Server-side enforcement is authoritative; these constants only drive UX.
// Source of truth: backend src/seeders/20240101000016-permissions.js

export const PERMISSIONS = {
  // ========== CONTROLLER ==========
  BRAND_CREATE: 'brand.create',
  BRAND_READ: 'brand.read',
  BRAND_UPDATE: 'brand.update',
  BRAND_DELETE: 'brand.delete',

  COUNTRY_CREATE: 'country.create',
  COUNTRY_READ: 'country.read',
  COUNTRY_UPDATE: 'country.update',
  COUNTRY_DELETE: 'country.delete',

  STATE_CREATE: 'state.create',
  STATE_READ: 'state.read',
  STATE_UPDATE: 'state.update',
  STATE_DELETE: 'state.delete',

  CITY_CREATE: 'city.create',
  CITY_READ: 'city.read',
  CITY_UPDATE: 'city.update',
  CITY_DELETE: 'city.delete',

  // ========== SOCIETY ==========
  SOCIETY_CREATE: 'society.create',
  SOCIETY_READ: 'society.read',
  SOCIETY_UPDATE: 'society.update',
  SOCIETY_DELETE: 'society.delete',
  SOCIETY_MANAGE_USERS: 'society.manage_users',

  SOCIETY_ADDRESS_CREATE: 'society_address.create',
  SOCIETY_ADDRESS_READ: 'society_address.read',
  SOCIETY_ADDRESS_UPDATE: 'society_address.update',
  SOCIETY_ADDRESS_DELETE: 'society_address.delete',

  SOCIETY_CONTACT_CREATE: 'society_contact.create',
  SOCIETY_CONTACT_READ: 'society_contact.read',
  SOCIETY_CONTACT_UPDATE: 'society_contact.update',
  SOCIETY_CONTACT_DELETE: 'society_contact.delete',

  SOCIETY_BANK_CREATE: 'society_bank.create',
  SOCIETY_BANK_READ: 'society_bank.read',
  SOCIETY_BANK_UPDATE: 'society_bank.update',
  SOCIETY_BANK_DELETE: 'society_bank.delete',

  WING_CREATE: 'wing.create',
  WING_READ: 'wing.read',
  WING_UPDATE: 'wing.update',
  WING_DELETE: 'wing.delete',

  FLAT_CREATE: 'flat.create',
  FLAT_READ: 'flat.read',
  FLAT_UPDATE: 'flat.update',
  FLAT_DELETE: 'flat.delete',

  // ========== MEMBERS ==========
  ENTITY_CREATE: 'entity.create',
  ENTITY_READ: 'entity.read',
  ENTITY_UPDATE: 'entity.update',
  ENTITY_DELETE: 'entity.delete',

  FLAT_OWNERSHIP_CREATE: 'flat_ownership.create',
  FLAT_OWNERSHIP_READ: 'flat_ownership.read',
  FLAT_OWNERSHIP_UPDATE: 'flat_ownership.update',
  FLAT_OWNERSHIP_DELETE: 'flat_ownership.delete',

  OCCUPANT_CREATE: 'occupant.create',
  OCCUPANT_READ: 'occupant.read',
  OCCUPANT_UPDATE: 'occupant.update',
  OCCUPANT_DELETE: 'occupant.delete',

  EMPLOYEE_CREATE: 'employee.create',
  EMPLOYEE_READ: 'employee.read',
  EMPLOYEE_UPDATE: 'employee.update',
  EMPLOYEE_DELETE: 'employee.delete',

  // ========== COMPLAINTS ==========
  COMPLAINT_CREATE: 'complaint.create',
  COMPLAINT_READ: 'complaint.read',
  COMPLAINT_UPDATE: 'complaint.update',
  COMPLAINT_DELETE: 'complaint.delete',
  COMPLAINT_ASSIGN: 'complaint.assign',
  COMPLAINT_STATUS_CHANGE: 'complaint.status_change',
  COMPLAINT_COMMENT: 'complaint.comment',

  // ========== VENDOR ==========
  VENDOR_CREATE: 'vendor.create',
  VENDOR_READ: 'vendor.read',
  VENDOR_UPDATE: 'vendor.update',
  VENDOR_DELETE: 'vendor.delete',

  VENDOR_CATEGORY_CREATE: 'vendor_category.create',
  VENDOR_CATEGORY_READ: 'vendor_category.read',
  VENDOR_CATEGORY_UPDATE: 'vendor_category.update',
  VENDOR_CATEGORY_DELETE: 'vendor_category.delete',

  VENDOR_BANK_CREATE: 'vendor_bank.create',
  VENDOR_BANK_READ: 'vendor_bank.read',
  VENDOR_BANK_UPDATE: 'vendor_bank.update',
  VENDOR_BANK_DELETE: 'vendor_bank.delete',

  VENDOR_BILL_CREATE: 'vendor_bill.create',
  VENDOR_BILL_READ: 'vendor_bill.read',
  VENDOR_BILL_UPDATE: 'vendor_bill.update',
  VENDOR_BILL_DELETE: 'vendor_bill.delete',
  VENDOR_BILL_APPROVE: 'vendor_bill.approve',

  VENDOR_PAYMENT_CREATE: 'vendor_payment.create',
  VENDOR_PAYMENT_READ: 'vendor_payment.read',
  VENDOR_PAYMENT_UPDATE: 'vendor_payment.update',
  VENDOR_PAYMENT_DELETE: 'vendor_payment.delete',

  VENDOR_TARIFF_CREATE: 'vendor_tariff.create',
  VENDOR_TARIFF_READ: 'vendor_tariff.read',
  VENDOR_TARIFF_UPDATE: 'vendor_tariff.update',
  VENDOR_TARIFF_DELETE: 'vendor_tariff.delete',

  VENDOR_SETTING_READ: 'vendor_setting.read',
  VENDOR_SETTING_UPDATE: 'vendor_setting.update',

  // ========== TASK MANAGEMENT ==========
  TASK_READ: 'task.read',
  TASK_CREATE: 'task.create',
  TASK_UPDATE: 'task.update',
  TASK_DELETE: 'task.delete',
  TASK_ASSIGN: 'task.assign',
  TASK_REASSIGN: 'task.reassign',
  TASK_DELEGATE: 'task.delegate',
  TASK_TRANSITION: 'task.transition',
  TASK_APPROVE: 'task.approve',
  TASK_REOPEN: 'task.reopen',
  TASK_CLOSE: 'task.close',
  TASK_COMMENT: 'task.comment',
  TASK_MANAGE_PROJECTS: 'task.manage_projects',
  TASK_BULK: 'task.bulk',
  TASK_DASHBOARD: 'task.dashboard',

  // ========== SETUP ==========
  INVOICE_TYPE_CREATE: 'invoice_type.create',
  INVOICE_TYPE_READ: 'invoice_type.read',
  INVOICE_TYPE_UPDATE: 'invoice_type.update',
  INVOICE_TYPE_DELETE: 'invoice_type.delete',

  DOCUMENT_SERIES_CREATE: 'document_series.create',
  DOCUMENT_SERIES_READ: 'document_series.read',
  DOCUMENT_SERIES_UPDATE: 'document_series.update',
  DOCUMENT_SERIES_DELETE: 'document_series.delete',

  INVOICE_SETTING_READ: 'invoice_setting.read',
  INVOICE_SETTING_UPDATE: 'invoice_setting.update',

  TARIFF_HEAD_CREATE: 'tariff_head.create',
  TARIFF_HEAD_READ: 'tariff_head.read',
  TARIFF_HEAD_UPDATE: 'tariff_head.update',
  TARIFF_HEAD_DELETE: 'tariff_head.delete',

  TARIFF_RATE_CREATE: 'tariff_rate.create',
  TARIFF_RATE_READ: 'tariff_rate.read',
  TARIFF_RATE_UPDATE: 'tariff_rate.update',
  TARIFF_RATE_DELETE: 'tariff_rate.delete',

  TARIFF_SLAB_CREATE: 'tariff_slab.create',
  TARIFF_SLAB_READ: 'tariff_slab.read',
  TARIFF_SLAB_UPDATE: 'tariff_slab.update',
  TARIFF_SLAB_DELETE: 'tariff_slab.delete',

  TAX_RULE_CREATE: 'tax_rule.create',
  TAX_RULE_READ: 'tax_rule.read',
  TAX_RULE_UPDATE: 'tax_rule.update',
  TAX_RULE_DELETE: 'tax_rule.delete',

  METER_READING_CREATE: 'meter_reading.create',
  METER_READING_READ: 'meter_reading.read',
  METER_READING_UPDATE: 'meter_reading.update',
  METER_READING_DELETE: 'meter_reading.delete',

  OPENING_BALANCE_CREATE: 'opening_balance.create',
  OPENING_BALANCE_READ: 'opening_balance.read',
  OPENING_BALANCE_UPDATE: 'opening_balance.update',
  OPENING_BALANCE_DELETE: 'opening_balance.delete',

  ROLE_CREATE: 'role.create',
  ROLE_READ: 'role.read',
  ROLE_UPDATE: 'role.update',
  ROLE_DELETE: 'role.delete',
  ROLE_ASSIGN_PERMISSIONS: 'role.assign_permissions',

  // ========== FINANCE ==========
  INVOICE_CREATE: 'invoice.create',
  INVOICE_READ: 'invoice.read',
  INVOICE_UPDATE: 'invoice.update',
  INVOICE_DELETE: 'invoice.delete',
  INVOICE_SEND: 'invoice.send',
  INVOICE_CANCEL: 'invoice.cancel',

  RECEIPT_CREATE: 'receipt.create',
  RECEIPT_READ: 'receipt.read',
  RECEIPT_UPDATE: 'receipt.update',
  RECEIPT_DELETE: 'receipt.delete',
  RECEIPT_ALLOCATE: 'receipt.allocate',

  CREDIT_NOTE_CREATE: 'credit_note.create',
  CREDIT_NOTE_READ: 'credit_note.read',
  CREDIT_NOTE_UPDATE: 'credit_note.update',
  CREDIT_NOTE_DELETE: 'credit_note.delete',
  CREDIT_NOTE_APPROVE: 'credit_note.approve',

  DEBIT_NOTE_CREATE: 'debit_note.create',
  DEBIT_NOTE_READ: 'debit_note.read',
  DEBIT_NOTE_UPDATE: 'debit_note.update',
  DEBIT_NOTE_DELETE: 'debit_note.delete',
  DEBIT_NOTE_APPROVE: 'debit_note.approve',

  ARREAR_READ: 'arrear.read',
  ARREAR_UPDATE: 'arrear.update',

  // ========== ACCOUNTS ==========
  CHART_OF_ACCOUNT_CREATE: 'chart_of_account.create',
  CHART_OF_ACCOUNT_READ: 'chart_of_account.read',
  CHART_OF_ACCOUNT_UPDATE: 'chart_of_account.update',
  CHART_OF_ACCOUNT_DELETE: 'chart_of_account.delete',

  JOURNAL_CREATE: 'journal.create',
  JOURNAL_READ: 'journal.read',
  JOURNAL_UPDATE: 'journal.update',
  JOURNAL_DELETE: 'journal.delete',
  JOURNAL_POST: 'journal.post',
  JOURNAL_IMPORT: 'journal.import',

  CASH_BANK_CREATE: 'cash_bank.create',
  CASH_BANK_READ: 'cash_bank.read',
  CASH_BANK_UPDATE: 'cash_bank.update',
  CASH_BANK_DELETE: 'cash_bank.delete',

  INVESTMENT_CREATE: 'investment.create',
  INVESTMENT_READ: 'investment.read',
  INVESTMENT_UPDATE: 'investment.update',
  INVESTMENT_DELETE: 'investment.delete',

  FIXED_ASSET_CREATE: 'fixed_asset.create',
  FIXED_ASSET_READ: 'fixed_asset.read',
  FIXED_ASSET_UPDATE: 'fixed_asset.update',
  FIXED_ASSET_DELETE: 'fixed_asset.delete',

  RECONCILIATION_CREATE: 'reconciliation.create',
  RECONCILIATION_READ: 'reconciliation.read',
  RECONCILIATION_UPDATE: 'reconciliation.update',
  RECONCILIATION_DELETE: 'reconciliation.delete',

  CLOSING_CREATE: 'closing.create',
  CLOSING_READ: 'closing.read',

  MEMBER_DAYBOOK_READ: 'member_daybook.read',

  // ========== REPORTS ==========
  INVOICE_REPORT_VIEW: 'invoice_report.view',
  INVOICE_REPORT_EXPORT: 'invoice_report.export',

  RECEIPT_REPORT_VIEW: 'receipt_report.view',
  RECEIPT_REPORT_EXPORT: 'receipt_report.export',

  GST_REPORT_VIEW: 'gst_report.view',
  GST_REPORT_EXPORT: 'gst_report.export',

  CD_NOTE_REPORT_VIEW: 'cd_note_report.view',
  CD_NOTE_REPORT_EXPORT: 'cd_note_report.export',

  MEMBER_LEDGER_REPORT_VIEW: 'member_ledger_report.view',
  MEMBER_LEDGER_REPORT_EXPORT: 'member_ledger_report.export',

  RECONCILIATION_REPORT_VIEW: 'reconciliation_report.view',
  RECONCILIATION_REPORT_EXPORT: 'reconciliation_report.export',

  INVOICE_AGING_REPORT_VIEW: 'invoice_aging_report.view',
  INVOICE_AGING_REPORT_EXPORT: 'invoice_aging_report.export',

  INTEREST_REPORT_VIEW: 'interest_report.view',
  INTEREST_REPORT_EXPORT: 'interest_report.export',

  TRIAL_BALANCE_REPORT_VIEW: 'trial_balance_report.view',
  TRIAL_BALANCE_REPORT_EXPORT: 'trial_balance_report.export',

  BALANCE_SHEET_REPORT_VIEW: 'balance_sheet_report.view',
  BALANCE_SHEET_REPORT_EXPORT: 'balance_sheet_report.export',

  PROFIT_LOSS_REPORT_VIEW: 'profit_loss_report.view',
  PROFIT_LOSS_REPORT_EXPORT: 'profit_loss_report.export',

  INCOME_EXPENDITURE_REPORT_VIEW: 'income_expenditure_report.view',
  INCOME_EXPENDITURE_REPORT_EXPORT: 'income_expenditure_report.export',

  RECEIPT_PAYMENT_REPORT_VIEW: 'receipt_payment_report.view',
  RECEIPT_PAYMENT_REPORT_EXPORT: 'receipt_payment_report.export',

  GENERAL_LEDGER_REPORT_VIEW: 'general_ledger_report.view',
  GENERAL_LEDGER_REPORT_EXPORT: 'general_ledger_report.export',

  CASH_BOOK_REPORT_VIEW: 'cash_book_report.view',
  CASH_BOOK_REPORT_EXPORT: 'cash_book_report.export',

  BANK_BOOK_REPORT_VIEW: 'bank_book_report.view',
  BANK_BOOK_REPORT_EXPORT: 'bank_book_report.export',

  JOURNAL_REGISTER_REPORT_VIEW: 'journal_register_report.view',
  JOURNAL_REGISTER_REPORT_EXPORT: 'journal_register_report.export',

  DAYBOOK_REPORT_VIEW: 'daybook_report.view',
  DAYBOOK_REPORT_EXPORT: 'daybook_report.export',

  INVESTMENT_REGISTER_REPORT_VIEW: 'investment_register_report.view',
  INVESTMENT_REGISTER_REPORT_EXPORT: 'investment_register_report.export',

  INVESTMENT_INTEREST_REPORT_VIEW: 'investment_interest_report.view',
  INVESTMENT_INTEREST_REPORT_EXPORT: 'investment_interest_report.export',

  FIXED_ASSET_REGISTER_REPORT_VIEW: 'fixed_asset_register_report.view',
  FIXED_ASSET_REGISTER_REPORT_EXPORT: 'fixed_asset_register_report.export',

  DEPRECIATION_SCHEDULE_REPORT_VIEW: 'depreciation_schedule_report.view',
  DEPRECIATION_SCHEDULE_REPORT_EXPORT: 'depreciation_schedule_report.export',

  // ========== COMPLIANCE ==========
  FLAT_TRANSFER_PREVIEW: 'flat_transfer.preview',
  FLAT_TRANSFER_CREATE: 'flat_transfer.create',
  FLAT_TRANSFER_READ: 'flat_transfer.read',
  FLAT_TRANSFER_REVERSE: 'flat_transfer.reverse',

  SHARE_CERTIFICATE_READ: 'share_certificate.read',
  SHARE_CERTIFICATE_UPDATE: 'share_certificate.update',

  // ========== NOTICES & CIRCULARS ==========
  NOTICE_CREATE: 'notice.create',
  NOTICE_READ: 'notice.read',
  NOTICE_UPDATE: 'notice.update',
  NOTICE_DELETE: 'notice.delete',
  NOTICE_PUBLISH: 'notice.publish',
  NOTICE_ARCHIVE: 'notice.archive',

  // ========== VISITOR MANAGEMENT (VMS) ==========
  // Three-segment codes under a shared `vms.` prefix, so a role granted the
  // `vms.*` wildcard picks up the whole module in one go.
  VMS_VISITOR_CREATE: 'vms.visitor.create',
  VMS_VISITOR_READ: 'vms.visitor.read',
  VMS_VISITOR_UPDATE: 'vms.visitor.update',
  VMS_VISITOR_DELETE: 'vms.visitor.delete',

  VMS_GATE_PASS_CREATE: 'vms.gate_pass.create',
  VMS_GATE_PASS_READ: 'vms.gate_pass.read',
  VMS_GATE_PASS_UPDATE: 'vms.gate_pass.update',
  VMS_GATE_PASS_REVOKE: 'vms.gate_pass.revoke',

  VMS_PRE_APPROVAL_CREATE: 'vms.pre_approval.create',
  VMS_PRE_APPROVAL_READ: 'vms.pre_approval.read',
  VMS_PRE_APPROVAL_UPDATE: 'vms.pre_approval.update',
  VMS_PRE_APPROVAL_DELETE: 'vms.pre_approval.delete',

  VMS_VISITOR_LOG_READ: 'vms.visitor_log.read',
  VMS_VISITOR_LOG_EXPORT: 'vms.visitor_log.export',

  VMS_DELIVERY_CREATE: 'vms.delivery.create',
  VMS_DELIVERY_READ: 'vms.delivery.read',
  VMS_DELIVERY_UPDATE: 'vms.delivery.update',
  VMS_DELIVERY_COMPLETE: 'vms.delivery.complete',

  VMS_CAB_CREATE: 'vms.cab.create',
  VMS_CAB_READ: 'vms.cab.read',
  VMS_CAB_UPDATE: 'vms.cab.update',
  VMS_CAB_COMPLETE: 'vms.cab.complete',

  VMS_SETTINGS_READ: 'vms.settings.read',
  VMS_SETTINGS_UPDATE: 'vms.settings.update',

  // ========== SYSTEM ==========
  USER_READ: 'user.read',
  USER_UPDATE: 'user.update',
  USER_MANAGE_ROLES: 'user.manage_roles',

  AUDIT_LOG_READ: 'audit_log.read',
  LOGIN_HISTORY_READ: 'login_history.read',

  // Employee attendance (shift punch in/out). Self-service endpoints
  // (/api/attendance/me*, /punch*) need NO permission — only an active
  // employee record. These codes gate the admin screens only.
  ATTENDANCE_READ_ALL: 'attendance.read_all',
  ATTENDANCE_EXPORT: 'attendance.export',
  ATTENDANCE_MANAGE: 'attendance.manage',
  ATTENDANCE_APPROVE: 'attendance.approve',

  // Employee shifts. These live in the `attendance` permission module
  // server-side, so they show up under the existing Attendance group on the
  // roles screen — there is no separate menu module for them.
  // SHIFT_ASSIGN also gates sending shift_id on the employee create/update
  // endpoints, not just the assignment endpoints.
  SHIFT_READ: 'shift.read',
  SHIFT_MANAGE: 'shift.manage',
  SHIFT_ASSIGN: 'shift.assign',

  SYSTEM_MANAGE_ROLES: 'system.manage_roles',
  SYSTEM_MANAGE_PERMISSIONS: 'system.manage_permissions',
  SYSTEM_VIEW_AUDIT_LOGS: 'system.view_audit_logs',

  // ========== MEMBER PORTAL (resident self-service) ==========
  // One code per "My Home" page, gating its sidebar entry, its route and the
  // matching /api/member/* endpoints. All six are granted to RESIDENT by
  // default; they are deliberately separate from complaint.read /
  // society.read so that giving a resident their portal does not also switch
  // on the staff menus those admin permissions drive.
  MEMBER_PORTAL_OVERVIEW: 'member_portal.overview',
  MEMBER_PORTAL_BILLS: 'member_portal.bills',
  MEMBER_PORTAL_PAYMENTS: 'member_portal.payments',
  MEMBER_PORTAL_LEDGER: 'member_portal.ledger',
  MEMBER_PORTAL_COMPLAINTS: 'member_portal.complaints',
  MEMBER_PORTAL_NOTICE_BOARD: 'member_portal.notice_board',

  // Core committee: read-only view of member complaints and managers' tasks.
  COMMITTEE_OVERSIGHT: 'committee.oversight',

  // Working Documents (bye-laws, minutes, certificates ...)
  SOCIETY_DOCUMENT_READ: 'society_document.read',
  SOCIETY_DOCUMENT_MANAGE: 'society_document.manage',
};

// Every resident-portal code — "holds any part of My Home" checks.
export const MEMBER_PORTAL_PERMISSIONS = [
  PERMISSIONS.MEMBER_PORTAL_OVERVIEW,
  PERMISSIONS.MEMBER_PORTAL_BILLS,
  PERMISSIONS.MEMBER_PORTAL_PAYMENTS,
  PERMISSIONS.MEMBER_PORTAL_LEDGER,
  PERMISSIONS.MEMBER_PORTAL_COMPLAINTS,
  PERMISSIONS.MEMBER_PORTAL_NOTICE_BOARD,
];

// System role codes — surfaced from /roles list. Cannot be edited/deleted.
export const SYSTEM_ROLE_CODES = ['SOCIETY_ADMIN', 'SOCIETY_MANAGER', 'RESIDENT'];

export default PERMISSIONS;
